/**
 * Vigencia de cuentas VIP.
 *
 * La UI ofrece opciones legibles ("Permanente", "30 días", …) pero el backend
 * espera una fecha `YYYY-MM-DD` (o ausente = permanente). Estas utilidades
 * traducen entre ambas representaciones.
 */

export const VALIDITY_PERMANENT = 'Permanente';
export const VALIDITY_OPTIONS = [
    VALIDITY_PERMANENT,
    '30 días',
    '60 días',
    '90 días',
] as const;

const DAYS_BY_OPTION: Record<string, number> = {
    '30 días': 30,
    '60 días': 60,
    '90 días': 90,
};

/** Convierte una opción de vigencia a fecha YYYY-MM-DD. `undefined` = permanente. */
export const validityOptionToDate = (option: string): string | undefined => {
    const days = DAYS_BY_OPTION[option];
    if (!days) return undefined;
    const d = new Date();
    d.setDate(d.getDate() + days);
    return d.toISOString().slice(0, 10);
};
